/** Angular */
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
/** Services */
import { BydAbstractService, BydConfigService } from '@sixense/byd-core-service';
/** Interfaces */

@Injectable({
  providedIn: 'root',
})
export abstract class BydAuthAbstractService extends BydAbstractService {
  /**
   * Implement inherited abstract member 'baseUrl' from BydAbstractService
   */
  public baseUrl: string;

  /**
   * The abstract endpoint path.
   */
  public abstract path: string;

  /**
   * @param injector creates a service injector instance.
   */
  constructor(injector: Injector) {
    super(injector.get(HttpClient), injector.get(BydConfigService));
    this.baseUrl = this.bydConfigService.injectedApiToken.apiUrl;
  }

  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public abstract createNewInstance(jsonObject: any): any;
}
